import { forwardRef } from 'react'
import { cn } from '@/lib/utils/cn'

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid, className, children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      data-invalid={invalid || undefined}
      aria-invalid={invalid || undefined}
      className={cn(
        'w-full cursor-pointer appearance-none rounded-sm border bg-surface text-primary text-md font-sans',
        'h-[var(--input-height)] pl-2.5 pr-7',
        'border-border-default bg-no-repeat bg-[position:right_10px_center]',
        'bg-[image:var(--select-chevron)]',
        'transition-[border-color,box-shadow] duration-fast',
        'hover:border-border-strong',
        'focus:outline-none focus:border-border-focus focus:shadow-focus',
        'disabled:cursor-not-allowed disabled:bg-surface-sunk disabled:text-text-disabled disabled:border-border-subtle',
        invalid &&
          'border-danger focus:border-danger focus:shadow-focus-danger hover:border-danger',
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  )
})
